import React from 'react';
import type { PiletApi } from '@sharefiledev/sharefile-appshell';
import { Skeleton } from 'antd';
import { LoadingSpinner } from '../LoadingSpinner';
import { BlockNames } from './block.types';
import type { RequestListsBlockProps } from './blockTypes';

const LazyRequestListsBlock = React.lazy(() => import('./RequestLists'));
export const AsyncRequestListsBlock: React.FC<RequestListsBlockProps> = props => {
	return (
		<React.Suspense fallback={<LoadingSpinner />}>
			<LazyRequestListsBlock {...props} />
		</React.Suspense>
	);
};

export const addBlocks = (piletApi: PiletApi) => {
	const LazyRequestListProviderBlock = React.lazy(
		() => import('./RequestListProviderBlock')
	);
	piletApi.registerExtension(BlockNames.Provider, props => (
		<React.Suspense fallback={<Skeleton />}>
			<LazyRequestListProviderBlock {...props} />
		</React.Suspense>
	));
};
